<template lang="pug">
  SspLayout(area="core")
    .row
      .col-md-12
        SspSaveForm(@onSubmit="save" :saveDisabled="!isValid" :saving="saving")
          .form-group
            label.col-sm-4.control-label Product Name
            .col-sm-8
              input.productName-input.form-control(type="text" placeholder="Product Name" v-model="product.name")
          .form-group
            label.col-sm-4.control-label Alias
            .col-sm-8
              input.alias-input.form-control(type="text" placeholder="Alias" v-model="product.alias")
          .form-group
            label.col-sm-4.control-label GTIN
            .col-sm-8
              input.gtin-input.form-control(type="text" placeholder="GTIN" v-model="product.gtin")
          .form-group
            label.col-sm-4.control-label Product ID
            .col-sm-8
              input.productId-input.form-control(type="text" placeholder="Product ID" v-model="product.customerProductReference")
          .form-group
            label.col-sm-4.control-label Package type
            .col-sm-8
              PackageSelect.packageType-select(v-model="product.packageTypeId")
          .form-group
            label.col-sm-4.control-label Validation response group
            .col-sm-8
              AtiGroupSelect(v-model="product.atiGroupId")
          .form-group
            label.col-sm-4.control-label Associated entry channel
            .col-sm-8
              EntrychannelsMultipleSelect(v-model="product.entryChannelIds")

</template>
<script>
import miniToastr from 'mini-toastr'
import Masterdata from '@/service/apis/Masterdata'
import AtiGroupSelect from '@/components/ssp/AtiGroupSelect'
import PackageSelect from '@/components/ssp/PackageSelect'
import EntrychannelsMultipleSelect from '@/components/ssp/EntrychannelsMultipleSelect'

export default {
  data() {
    return {
      saving: false,
      product: {
        alias: null,
        atiGroupId: null,
        customerProductReference: null,
        entryChannelIds: [],
        gtin: null,
        name: null,
        packageTypeId: null
      }
    }
  },
  created() {
    if (this.productId) {
      this.getProduct()
    }
  },
  methods: {
    getProduct() {
      Masterdata.getProduct(this.productId)
        .then((resp) => {
          this.product = resp.data
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    save() {
      this.saving = true
      const product = { ...this.product }
      const call = this.productId ? Masterdata.updateProduct(this.productId, product) : Masterdata.createProduct(product)
      call
        .then(() => {
          miniToastr.success('Product successfully saved')
          this.$router.go(-1)
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  watch: {
    productId() {
      this.getProduct()
    }
  },
  computed: {
    productId() {
      return parseInt(this.$route.params.id, 10)
    },
    isValid() {
      return this.product.name
    }
  },
  components: {
    AtiGroupSelect,
    PackageSelect,
    EntrychannelsMultipleSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/product/ProductEdit.vue